export const PUBLIC_PATHS = {
  LANDING: "/",
  LANDINGDATA: "/:location",
  LOGIN: "/auth/login",
  AUTH: "/auth",
  SIGNUP: "/auth/signup",
  REFER_SIGNUP: "/auth/signup/referralCode/:referral_code/:promotion?",
  RESET_PASS: "/auth/reset-password",
  PASS_OTP: "/auth/confirm-password-otp",
  CHANGE_PASS: "/auth/change-password",
  OFFLINE: "/offline",
  PUBLIC_PACKAGES_PARTNERSHIP: "/packages/location/:type/:referral_code",
  PUBLIC_PACKAGES: "/packages/location/:type/:search?",
  PACKAGES_DETAIL: "/packages/:id/:referral_code?",
  GALLERY: "/gallery",
  ABOUT: "/about",
  ALL_CONTENTS: "/contents",
  EVENTS: "/contents/events",
  WEBINARS: "/contents/webinars",
  TRIPS: "/contents/trips",
  ARTICLES: "/contents/articles",
  VIEW_CONTENT: "/contents/details/:type/:id",
  PLANNER_PROFILE: "/planner/:plannerId",
};

export const PRIVATE_PATHS = {
  DASHBOARD: "/dashboard",
  PACKAGES: "/packages",
  SEARCH_PACKAGES: "/packages/location/:type/:search?",
  NOT_FOUND: "/404",
  OFFLINE: "/offline",
  PACKAGES_DETAILS: "/packages/:id/:referral_code?",
  TRIPS: "/trips",
  CHAT: "/chat",
  WISHLIST: "/wishlist",
  TRANSACTION: "/transactions",
  ESTIMATE: "estimate",
  LEGAL: "legal/terms",
  SUPPORT: "/support",
  TERMS: "terms",
  REFER: "/referal",
  COUPON: "/coupons",
  CUSTOMTRIP: "/customtrips",
  CUSTOMTRIP_DETAILS: "/customtrips/:id/:tabName/details",
  TRIPVAULT: "/tripvault",
  PLANTRIP: "/plan-trip",
  POLICY: "legal/policy",
  PROFILE: "profile",
  PLAN_TRIP: "/plan-trip",
  PLANTRIP_DETAILS: "/plan-trip/:id/details",
  PLANNER_PROFILE_DASHBOARD: "/planner/:plannerId",
};
